<template>
  <div class="mobile-header">
    <div class="mobile-wrapper">
      <div class="mobile-menu-wrapper" @click="toggleMobileSideBar">
        <i class="el-icon-s-fold"  v-if="isMobileSideBar" :class="[isMobileSideBar?'active':'']"></i>
        <i class="el-icon-s-unfold" v-else></i>
      </div>
      <div class="header-content" @click="navToHome"><img src="@/assets/logo/florina-2021-black.png" class="logo" alt=""></div>
      <div class="control" @click="toggleToolBar">
        <i class="el-icon-setting" :class="[isRightToolBar?'animated zoomIn active':'']"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name:'mobile',
  computed:{
    isMobileSideBar(){
      return this.$store.state.app.mobileSideBar
    },
    isRightToolBar(){
      return this.$store.state.app.rightToolBar
    },
    isMobile(){
      return this.$store.state.app.isMobileMode
    }
  },
  methods:{
    ...mapMutations({
      'ToggleMobileSideBar':'app/ToggleMobileSideBar',
      'ToggleToolBar':'app/ToggleToolBar',
      'CloseMobileSideBar':'app/CloseMobileSideBar',
      'CloseToolBar':'app/CloseToolBar'
    }),
    navToHome(){
      if(this.isMobile){
        this.CloseMobileSideBar()
        this.CloseToolBar()
      }
			this.$router.push({path:'/'})
    },
    toggleMobileSideBar(){
      this.ToggleMobileSideBar()
    },
    toggleToolBar(){
      this.ToggleToolBar()
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header{
  width: 100%;
  height: 54px;
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
  .mobile-wrapper{
    display: flex;
    height: 100%;
    overflow: hidden;
    .mobile-menu-wrapper{
      flex: 54px 0 0;
      width: 54px;
      height: 100%;
      text-align: center;
      line-height: 46px;
      color: #333;
      font-size: 24px;
      cursor: pointer;
      overflow: hidden;
    }
    .header-content{
      flex: 1;
      text-align: center;
      height: 100%;
      line-height: 46px;
      overflow: hidden;
      img{
        max-height: 80%;
        margin-top: 5px;
      }
    }
    .control{
      flex: 54px 0 0;
      width: 54px;
      height: 100%;
      text-align: center;
      line-height: 46px;
      color: #333;
      font-size: 14px;
      overflow: hidden;
      color: #333;
      font-size: 24px;
    }
    .active{
      color: #ffe21c;
    }
  }
}
// @media screen and  (min-width:1200px) {
//   .mobile-header{
//     display: none;
//   }
// }
</style>

